module.exports = __webpack_public_path__ + "static/js/1.29c80261.chunk.worker.js"